<template>
  <div class="cash">
    <div class="balance">
      <span class="txt">现金余额：</span>
      <p class="right">
        <i class="icon"></i
        ><span class="orange">{{
          cashUserInfo.cashOutAmount ? cashUserInfo.cashOutAmount / 100 : 0
        }}</span
        ><span class="yuan">元</span>
      </p>
    </div>
    <div class="amount">
      <div class="title">提现金额</div>
      <div class="desc">每个人每天只能提现一次</div>
      <div class="block">
        <div
          class="item"
          :class="{ on: item.settingId === curCashInfo.settingId, nostock: item.status === -101 }"
          v-for="(item, i) in cashInfoList"
          :key="i"
          @click="changeCash(item)"
        >
          <div class="num" :class="{ ramdon: item.cashOutAmount === 0 }">
            {{
              item.cashOutAmount === 0
                ? '随机金额'
                : '￥' + item.cashOutAmount / 100
            }}
          </div>
          <div class="tip" v-if="item.cashOutAmount === 0">无需承担税费</div>
          <div class="tip" v-else>
            实际到账{{ item.cashOutRealAmount / 100 }}元
          </div>
          <div class="stock-tip" v-if="item.status === -101">今日库存用完</div>
        </div>
      </div>
      <div class="bottom">
        <div class="line">
          <p>提现到微信</p>
          <p class="nickname" v-if="isBind">
            <span>{{ cashUserInfo.oauthAccounts[0].oauthName }}</span>
          </p>
          <p class="nickname" v-else>需要打款请先绑定微信</p>
        </div>
        <div class="line">
          <p>提现金额</p>
          <p>
            <span class="gray" v-if="!isBind">暂无数据</span>
            <span
              class="orange random"
              v-else-if="curCashInfo.cashOutAmount === 0"
              >随机金额</span
            ><span class="orange" v-else
              >￥{{
                curCashInfo.cashOutAmount ? curCashInfo.cashOutAmount / 100 : 0
              }}</span
            >
          </p>
        </div>
      </div>
    </div>
    <div class="tips">
      <p>注意事项</p>
      <p>1、连续14天未访问“积分中心”，余额将被清零</p>
      <p>
        <span>2、提现成功后，金额将在 5 个工作日内到账，如有疑问请联系</span
        ><span class="orange" @click="jumpServer">客服</span>
      </p>
      <p>3、每天的提现时间段为9点-23点，非此时间段不可提现</p>
    </div>
    <!--立即提现-->
    <div
      class="footer-btn"
      :class="{
        disabled: cashUserInfo.cashOutAmount === 0 || info.userTaskStatus != 1,
      }"
      v-if="isBind"
      @click="handleCash"
    >
      立即提现
    </div>
    <div class="footer-btn" @click="handleBind" v-else>立即绑定</div>

    <cashDialog
      v-if="cashResult.isShow == true"
      :cashResult="cashResult"
      @close="handleClose"
    />

    <versionDialog ref="versionDialog" />
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import { loginMixin } from '@/utils/mixin'
import { getCashInfo, wxAuth, getCash } from '@/request/cash'
import cashDialog from '@/v2-components/d-cash-success'
import versionDialog from '@/v2-components/d-version-tips'
import { jumpPage } from '@/utils/mUtil'

export default {
  mixins: [loginMixin],
  components: { cashDialog, versionDialog },
  data() {
    return {
      info: {},
      cashInfoList: [],
      curCashInfo: {},
      cashResult: {
        type: 0,
        isShow: false,
        realMount: 0.17,
      },
      apiDoing: false,
    }
  },
  mounted() {
    MgtvApi.setWebviewTitle({
      title: '现金提现',
    })
    this.$nextTick(() => {
      this.getCashInfo()
      MgStat.send('pv', {}, { cntp: 'score_withdrawMoney' })
    })

    // 返回页面刷新
    MgtvApi.registerhandler('webviewBecomeActive', {}, () => {
      this.$store.dispatch('queryCashUserInfo')
    })

    if (!this.isLogin) {
      return this.clickLogin()
    }
  },
  methods: {
    async getCashInfo() {
      const res = await getCashInfo()
      if (res.code === 200 && res.data) {
        this.info = res.data
        this.cashInfoList = res.data.taskSettings
        this.curCashInfo = res.data.taskSettings[0]
      } else {
        this.$toast(res.msg)
      }
    },
    changeCash(item) {
      if (item.status === -101) {
        return;
      }

      if (!this.isBind) {
        this.$toast('请先绑定微信')
        return
      }
      if (!this.checkValid()) {
        return
      }

      this.curCashInfo = item
    },
    checkValid() {
      if (!this.$refs.versionDialog.checkVersion()) {
        return false
      } else if (this.cashUserInfo.cashOutAmount === 0) {
        this.$toast('暂无可提取的现金，快去做任务吧~')
        return false
      } else if (this.info.userTaskStatus != 1) {
        this.$toast('今日提现机会已用完，请明日再来~')
        return false
      } else {
        return true
      }
    },
    async handleCash() {
      if (this.apiDoing) {
        return
      }
      if (!this.isLogin) {
        return this.clickLogin()
      }
      if (!this.checkValid()) {
        return
      }
      try {
        this.apiDoing = true
        const res = await getCash({
          settingId: this.curCashInfo.settingId,
          taskSign: this.info.taskSign,
          cashOutType: 1, // 1-微信打款
        })
        if (res.code === 200) {
          this.$store.dispatch('queryCashUserInfo')
          this.cashResult = {
            type: this.curCashInfo.cashOutAmount,
            isShow: true,
            realMount: (res.data.cashOutRealAmount / 100).toFixed(2),
          }
        } else if (res.code === 4004 || res.code === 4008) {
          this.$toast('系统升级维护中，暂停提现功能')
        } else if (res.code === 4003) {
          this.$toast('您今天已提过现，请明天再来吧')
        } else if (res.code === 4002) {
          this.$toast('今日平台提现总额已达上限，请明天早点来~')
        } else if (res.code === 4007) {
          if (this.curCashInfo.cashOutAmount === 0) {
            this.$toast('余额不足，快去赚现金吧~')
          } else {
            this.$toast('金额不足，请尝试其他提现金额')
          }
        } else if (res.code === 4009) {
          this.$toast('当前时间段不支持提现')
        } else {
          this.$toast(res.msg)
        }
      } catch (e) {
        console.log(e)
      } finally {
        this.apiDoing = false
      }
    },
    handleBind() {
      if (this.apiDoing) {
        return
      }
      if (!this.isLogin) {
        return this.clickLogin()
      }
      if (!this.$refs.versionDialog.checkVersion()) {
        return
      }
      try {
        this.apiDoing = true
        MgtvApi.callhandler(
          'mgAuthorization',
          {
            type: 'weixin',
          },
          async (res) => {
            console.log('拉起微信授权成功：', res)
            if (typeof res == 'string') {
              res = JSON.parse(res)
            }
            const { code, data } = res
            const realData = typeof data == 'string' ? JSON.parse(data) : data
            if (code == 200) {
              const wxres = await wxAuth(realData.code) // 绑定微信
              if (wxres.code === 200) {
                this.$toast('绑定成功')
                this.$store.dispatch('queryCashUserInfo')
              } else if (wxres.code === 4001) {
                this.$toast('微信认证失败')
              } else if (wxres.code === 4006) {
                this.$toast('绑定失败，该微信账号已绑定其他用户', null, 8000)
              } else {
                this.$toast(wxres.msg, null, 8000)
              }
            } else {
              // jssdk绑定失败提示
              this.$toast(
                '微信授权失败，请确认您已正确登录微信并授权应用访问。'
              )
            }
          }
        )
      } catch (e) {
        console.log(e)
      } finally {
        this.apiDoing = false
      }
    },
    handleClose() {
      this.cashResult.isShow = false
    },
    jumpServer() {
      jumpPage(
        'https://h5-kf.imgo.tv/temp.html?app_id=201&platform=1&system=3&entry=4&business_id=1&pageName=h5&show_self_service=1&show_questions=1&show_faq=1'
      )
    },
  },
  computed: {
    ...mapState(['isMGTV', 'userInfo', 'cashUserInfo', 'devicesInfo']),
    ...mapGetters(['isLogin']),
    isBind() {
      return (
        this.cashUserInfo?.oauthAccounts &&
        this.cashUserInfo?.oauthAccounts[0]?.oauthStatus === 1
      )
    },
  },
}
</script>

<style lang="less" scoped>
.cash {
  background: #f5f5f5;
  padding: 36px;
  width: 100%;
  height: 100vh;
  // font-family: AlimamaFangYuanTiVF-Thin;
  .balance {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 30px;
    font-size: 28px;
    .txt {
      padding-top: 6px;
      font-weight: 600;
      font-size: 28px;
      color: rgba(0, 0, 0, 0.8);
    }
    .right {
      display: flex;
      align-items: center;
    }
    .orange {
      line-height: 64px;
      .sizeColor(64px, #FDB03E);
      padding: 0 10px;
      font-weight: bold;
      font-family: DIN Alternate, DIN Alternate;
    }
    .icon {
      .bgCover('../../../assets/v2/cash/balance.png');
      .wh(40px, 40px);
      display: inline-block;
      margin-top: 8px;
    }
    .yuan {
      line-height: 32px;
      font-weight: 600;
      font-size: 28px;
      color: rgba(0, 0, 0, 0.6);
      display: inline-block;
      padding-top: 14px;
    }
  }
  .amount {
    padding: 36px 12px;
    background: #fff;
    border-radius: 36px;
    margin: 36px 0;
    .title {
      // font-family: AlimamaFangYuanTiVF-Thin;
      font-weight: 600;
      font-size: 32px;
      color: rgba(0, 0, 0, 0.8);
      padding-left: 24px;
      line-height: 32px;
    }
    .desc {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 24px;
      color: rgba(0, 0, 0, 0.4);
      padding-left: 24px;
      margin-top: 36px;
      line-height: 32px;
    }
    .block {
      display: flex;
      flex-wrap: wrap;
      margin-top: 12px;
      .item {
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 194px;
        height: 153px;
        border-radius: 24px 24px 24px 24px;
        margin: 12px;
        background: rgba(0, 0, 0, 0.03);
        padding-top: 2px;

        // 无库存时覆盖样式
        &.nostock {
          .num {
            color: rgba(0, 0, 0, 0.2);
          }
          .tip {
            color: rgba(0, 0, 0, 0.2);
          }
        }
        // 库存用完提示
        .stock-tip {
          position: absolute;
          left: 0;
          right: 0;
          bottom: 0;
          text-align: center;
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 22px;
          color: #FDB03E;
          background: rgba(253, 176, 62, 0.1);
          border-radius: 0px 0px 24px 24px;
        }
        .num {
          font-weight: 600;
          font-size: 40px;
          color: rgba(0, 0, 0, 0.8);
          font-family: DIN Alternate, DIN Alternate;
          line-height: 40px;
          &.ramdon {
            font-size: 28px;
          }
        }
        .tip {
          font-size: 22px;
          color: rgba(0, 0, 0, 0.4);
          margin-top: 8px;
        }
        &.on {
          background: rgba(253, 176, 62, 0.1);
          border: 4px solid #fdb03e;
          .num {
            color: #fdb03e;
            font-weight: bold;
          }
        }
      }
    }
    .bottom {
      margin-top: 28px;
      padding: 0 24px;
      display: flex;
      flex-direction: column;
      .line {
        padding-top: 36px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 24px;
        color: rgba(0, 0, 0, 0.8);
        display: flex;
        justify-content: space-between;
        align-items: center;
        line-height: 32px;
        .nickname {
          font-size: 28px;
          color: rgba(0, 0, 0, 0.8);
          display: flex;
          align-items: center;
        }
        img {
          width: 50px;
          height: 50px;
          border-radius: 12px 12px 12px 12px;
          margin-right: 16px;
        }
        .orange {
          .sizeColor(40px, #FDB03E);
          font-family: DIN Alternate, DIN Alternate;
          &.random {
            font-size: 28px;
            font-weight: 600;
          }
        }
        .gray {
          .sizeColor(28px, rgba(0,0,0,0.4));
        }
      }
    }
  }
  .tips {
    margin: 24px;
    p {
      font-weight: 400;
      font-size: 24px;
      color: rgba(0, 0, 0, 0.4);
      padding-top: 12px;
      line-height: 28px;
      .orange {
        .sizeColor(24px, #FDB03E);
        text-decoration: underline;
      }
    }
  }
  .footer-btn {
    .sizeColor(30px, #fff);
    .wh(534px, 102px);
    font-weight: bold;
    position: fixed;
    left: 50%;
    bottom: 104px;
    transform: translateX(-50%);
    display: block;
    line-height: 102px;
    text-align: center;
    background: linear-gradient(45deg, #fdb03e 0%, #ffc369 100%);
    border-radius: 24px;
    &.disabled {
      background: #eeeeee;
      color: rgba(0, 0, 0, 0.1);
    }
  }
}
</style>
